import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { initFlowbite } from 'flowbite';
// import { initFlowbite } from 'flowbite';
import { ProjectService } from 'src/app/modules/project/services/project.service';

@Component({
  selector: 'app-api-logs',
  templateUrl: './api-logs.component.html',
  styleUrls: ['./api-logs.component.css']
})
export class ApiLogsComponent implements OnInit {
  @ViewChild('dropdownMenu') dropdownMenu: ElementRef;

  logsData: any[] = [];
  isModalOpen = false;
  selectedLog: any;
  dataNotFoundMsg: boolean = false;
  filterOptions = [
    { value: 1, text: 'Today' },
    {value :2,text :'Yesterday'},
    { value: 7, text: 'Last 7 days' },
    { value: 15, text: 'Last 15 days' },
    { value: 30, text: 'Last 30 days' },
  ];
  
  filter: number = 1;
  // pagination related
  public values: number = 7
  public currentPage: number = 1;
  public itemsPerPage: number = 10;
  public totalItems: number;
  public totalPages: number;
  public apiUrl: string = "api/logs/project";
  public startingIndex: number;
  public searchQuery: string = ''
  docs: any;
  protected previous: boolean = false;
  protected next: boolean = false;

  constructor(private projectSevices: ProjectService) { }

  ngOnInit(): void {
    initFlowbite();
     this.getApiLogsDetails();
  }

  /**
   * Gets api logs details
   * @param page
   * @param limit
   */
  getApiLogsDetails() {
    this.projectSevices.getApiLogsDetails(this.currentPage, this.itemsPerPage, this.searchQuery, this.filter).subscribe({
      next: (response: any) => {
        this.logsData = response.data.docs;        
        this.previous = response.data.hasPrePage;
        this.next = response.data.hasNextPage;
        this.totalPages = response.data.totalPages;
        this.totalItems = response.data.totalDocs;
        this.startingIndex = response.data.pagingCounter;
      },
      error: (error: any) => {
        console.log(error);
      }
    })
  }



  /**
   * Opens modal
   * @param {any} data
   */
  openModal(data: any) {
    this.selectedLog = data;
    this.isModalOpen = true;
  }

  /**
   * Closes modal
   */
  closeModal() {
    this.isModalOpen = false;
  }

  /**
   * Lists api logs component
   * @param list
   */
  list(list: any) {
    this.logsData = list;
    // initFlowbite();

  }

  /**
 * Sets starting index
 * @param{number} index
 */
  setStartingIndex(index: number) {
    this.startingIndex = index;
  }

  /**
 * Determines whether page change on {Pagination}
 * @param{number} page
 */
  onPageChange(page: number): void {
    this.currentPage = page;
    this.getApiLogsDetails();
  }

  handleSearch(event: any) {
    this.projectSevices.onSearch(event, (searchTerm: string) => {
      this.searchQuery = searchTerm;
      this.getApiLogsDetails();
    });
  }

  /**
   * Determines whether option selected on
   * @param selectedFilter
   */
  onOptionSelected(selectedFilter: any): void {
    this.filter = selectedFilter;
    this.currentPage = 1; // Reset to first page when filter changes
    this.getApiLogsDetails();
  }
}
